// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rmpC","input":"styles_input__3Kb8a"};